export const richTextDirective = ($sce) => {
  "ngInject";

  return {
    restrict: "A",
    scope: {
      richText: "=",
    },
    link: (scope, element, attrs) => {
        const formattedText = scope.richText.replace(/Roboto/gi, "Lato");
        const html = $sce.trustAsHtml(formattedText);
        element.html(html);
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/common/components/rich-text/rich-text.directive.js